import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';

import { makeGetCosts } from '../../../store/selectors';

const defaultGreen = green[200];
const defaultOrange = orange[200];

const styles = theme =>({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: '10px',
    minWidth: '300px',
    flexBasis: '500px',
    maxWidth: '500px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    paddingLeft: '10px',
    paddingRight: '0px',
    paddingTop: '0px',
    paddingBottom: '5px',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '30px',
  },
  barChart: {
  }
})




const ProjectMetrics = (props) => {
  const {classes, costs} = props;

  return(
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="title">
          Project Metrics
        </Typography>
        <Button color="primary">
          View
        </Button>
      </div>
      <Divider />
      <div className={classes.content}>
          <BarChart className={classes.barChart}
                    width={400} height={300}
                    data={costs.barChartData} stackOffset="sign"
                    margin={{top: 0, right: 0, left: 0, bottom: 0}}>
           <XAxis dataKey="name"/>
           <YAxis/>
           <CartesianGrid strokeDasharray="3 3"/>
           <Tooltip/>
           <Legend style={{padding: '30px'}} />
           <Bar dataKey="costs" stackId="a" fill={defaultOrange} />
           <Bar dataKey="profit" stackId="a" fill={defaultGreen} />
          </BarChart>
      </div>
    </div>
  );
};

const makeMapStateToProps = () => {
  const getCosts = makeGetCosts();
  const mapStateToProps = (state, props) => {
    return {
      costs: getCosts(state, props)
    }
  };

  return mapStateToProps;
}

export default compose(
  withStyles(styles),
  connect(makeMapStateToProps)
)(ProjectMetrics);



// WEBPACK FOOTER //
// ./src/components/admin/Project/ProjectMetrics.jsx